import { createApi } from '@reduxjs/toolkit/query/react'
import { customBaseQuery } from './custom-base-query'

/**
 * Base API configuration for RTK Query
 * Uses custom baseQuery that integrates with our existing error handling system
 * for token refresh, cross-tab coordination, and comprehensive error management
 */
export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: customBaseQuery,
  tagTypes: ['Task', 'UserLimitations', 'UserBillingInfo', 'ActivationSteps', 'CreditUsage'],
  endpoints: () => ({}),
})
